import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { videoItems } from '@/mocks/home';

const [featured, ...rest] = videoItems;

export default function VideoSection() {
  return (
    <section id="videos" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="视频内容"
          title="视频内容库，从生活记录到创作教程"
          desc="视频标注了时长、主题与观看热度，方便你按兴趣挑选。下面是本期推荐与近期更新。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Reveal>
            <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="relative h-56 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={featured.thumbnail}
                  alt={`${featured.title}｜香蕉社区视频内容`}
                  title={`${featured.title} 香蕉社区视频`}
                  className="h-full w-full object-top object-cover"
                />
                <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/75 px-2 py-1 text-xs text-background-50">
                  {featured.duration}
                </span>
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  本期推荐
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                  {featured.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.desc}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-3-line" aria-hidden="true" /> {featured.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-price-tag-3-line" aria-hidden="true" /> {featured.category}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" aria-hidden="true" /> {featured.views} 次观看
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="flex flex-col gap-4">
            {rest.map((item, index) => (
              <Reveal key={item.id} delay={(index + 1) * 80}>
                <article className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 sm:flex-row">
                  <div className="relative h-40 w-full overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44 sm:shrink-0">
                    <img
                      src={item.thumbnail}
                      alt={`${item.title}｜香蕉社区视频内容`}
                      title={`${item.title} 香蕉社区视频`}
                      className="h-full w-full object-top object-cover"
                    />
                    <span className="absolute bottom-2 right-2 rounded bg-foreground-950/75 px-1.5 py-0.5 text-xs text-background-50">
                      {item.duration}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col">
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">
                      {item.desc}
                    </p>
                    <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-price-tag-3-line" aria-hidden="true" /> {item.category}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-user-3-line" aria-hidden="true" /> {item.author}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-eye-line" aria-hidden="true" /> {item.views}
                      </span>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}